import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, map, Observable, Subject } from 'rxjs';
import { environment } from 'src/environments/environment';
import { Module } from 'src/app/models/module.model';
import { ModuleResponse } from 'src/app/models/moduleVid.model';
import { ItemAccess } from 'src/app/models/access.model';
import { DoctorProfile } from 'src/app/models/profile.model';
import { LoggingService } from '../consoleLogs';
import { ApiResponse, NewsResponse } from 'src/app/models/news-list.model';
import { NewsItem } from 'src/app/models/getNews.model';
import { ModuleListResponse } from 'src/app/models/module-list.model';
import { ModuleReportResponse } from 'src/app/models/analitics.model';
import { WebApiResponse } from 'src/app/models/webinar-analitics';
import { ProfileDynamicDetailsResponse } from 'src/app/models/getDoctorProfile.model';
import { ReportResponse } from 'src/app/models/reports.model';
import { TenantUIResponse } from 'src/app/models/tenant.model';
import { SurveyListResponse } from 'src/app/models/survey-list.model';
import { DoctorsListResponse } from 'src/app/models/doctor-module.model';
import { BookResponse } from 'src/app/models/library.model';
import { PermissionResponse } from 'src/app/models/permission.model';
import { WebinarCountsResponse } from 'src/app/pages/ui-components/webinar-list/webinar-list.component';
import { ZoomAnalytics } from 'src/app/models/zoom-analitics';
// import { title } from 'process';
@Injectable({
  providedIn: 'root',
})
export class BaseServicesService {
  private nameCache = new Map<string, string>();
  private breadcrumbUpdateSubject = new BehaviorSubject<{ id: string; name: string } | null>(null);

  breadcrumbUpdate$ = this.breadcrumbUpdateSubject.asObservable();

  /**
   * Set breadcrumb name for an ID
   */
  setBreadcrumbName(id: string, name: string): void {
    this.nameCache.set(id, name);
    this.breadcrumbUpdateSubject.next({ id, name });
  }

  /**
   * Get cached breadcrumb name
   */
  getBreadcrumbName(id: string): string | null {
    return this.nameCache.get(id) || null;
  }
  private selectedModuleTitle = new BehaviorSubject<string>('All');
  selectedModuleTitle$ = this.selectedModuleTitle.asObservable();

  setSelectedTitle(title: string): void {
    this.selectedModuleTitle.next(title);
  }

  getSelectedTitle(): string {
    return this.selectedModuleTitle.getValue();
  }

  private collapsedSource = new BehaviorSubject<boolean>(false);
  collapsed$ = this.collapsedSource.asObservable();

  setSidebarCollapsed(collapsed: boolean) {
    this.collapsedSource.next(collapsed);
  }

  toggleCollapsed() {
    this.collapsedSource.next(!this.collapsedSource.value);
  }


  private collapseSidenavSource = new Subject<void>();
  collapseSidenav$ = this.collapseSidenavSource.asObservable();

  collapseSidenav() {
    this.collapseSidenavSource.next();
  }
  private expandSidenavSource = new Subject<void>();
  expandSidenav$ = this.expandSidenavSource.asObservable();

  expandSidenav() {
    this.loggingService.log("calling expandSidenav")

    this.expandSidenavSource.next();
  }

  private preselectedDate = new BehaviorSubject<Date | null>(null);

  setPreselectedDate(date: Date) {
    this.preselectedDate.next(date);
  }

  getPreselectedDate() {
    return this.preselectedDate.asObservable();
  }

  private preselectedTime = new BehaviorSubject<string | null>(null);

  setPreselectedTime(time: string) {
    this.preselectedTime.next(time);
  }

  getPreselectedTime(): Observable<string | null> {
    return this.preselectedTime.asObservable();
  }

  private profilePicUrlSource = new BehaviorSubject<string>('');
  profilePicUrl$: Observable<string> = this.profilePicUrlSource.asObservable();

  private profileNameSource = new BehaviorSubject<string>('');
  profileName$: Observable<string> = this.profileNameSource.asObservable();

  private sessionUuidSubject = new BehaviorSubject<string | null>(null);

  private userNameSubject = new BehaviorSubject<string>('');
  private userAvatarSubject = new BehaviorSubject<string>('');
  private userRoleSubject = new BehaviorSubject<string>('');

  userName$ = this.userNameSubject.asObservable();
  userAvatar$ = this.userAvatarSubject.asObservable();
  userRole$ = this.userRoleSubject.asObservable();

  get sessionUuid$() {
    return this.sessionUuidSubject.asObservable();
  }

  setSessionUuid(uuid: string | null): void {
    this.sessionUuidSubject.next(uuid);
  }

  getSessionUuid(): string | null {
    return this.sessionUuidSubject.value;
  }

  updateProfilePicUrl(url: string): void {
    this.profilePicUrlSource.next(url);
  }
  updateProfileName(name: string): void {
    this.profileNameSource.next(name);
  }

  private itemIdSource = new BehaviorSubject<string | null>(null); // Initial value is null
  itemId$ = this.itemIdSource.asObservable(); // Observable to subscribe to in other components

  // Method to set the itemId
  setItemId(itemId: string) {
    this.itemIdSource.next(itemId);
  }

  // BehaviorSubject to hold the contentAccess value
  private contentAccessSource = new BehaviorSubject<any>(null); // Initial value is `null`
  contentAccess$ = this.contentAccessSource.asObservable(); // Observable for components to subscribe

  // Method to update the contentAccess value
  setContentAccess(contentAccess: any): void {
    this.contentAccessSource.next(contentAccess);
  }

  api: string = environment.apiUrl;
  private getHeaders(): HttpHeaders {
    const token = localStorage.getItem('authToken');
    return new HttpHeaders({
      Authorization: `Bearer ${token}`,
    });
  }

  private getDocHeaders(): HttpHeaders {
    const token = localStorage.getItem('docAuth');
    return new HttpHeaders({
      Authorization: `Bearer ${token}`,
    });
  }
  private getUserTimezone(): string {
    return Intl.DateTimeFormat().resolvedOptions().timeZone;
  }

  private getHeadersUuid(): HttpHeaders {
    const token = localStorage.getItem('authToken');
    const sessionUuid = localStorage.getItem('sessionUuid');

    let headers = new HttpHeaders({
      Authorization: `Bearer ${token}`,
    });

    if (sessionUuid) {
      headers = headers.set('MODULE-UUID', sessionUuid);
    }

    return headers;
  }
  private getHeadersContentUuid(): HttpHeaders {
    const token = localStorage.getItem('authToken');
    const sessionUuid = localStorage.getItem('sessionUuid');
    const contentUuid = localStorage.getItem('content-uuid');
    let headers = new HttpHeaders({
      Authorization: `Bearer ${token}`,
    });

    if (sessionUuid) {
      headers = headers.set('MODULE-UUID', sessionUuid);
    }
    if (contentUuid) {
      headers = headers.set('CONTENT-UUID', contentUuid);
    }

    return headers;
  }

  // private getHeadersContentUuidDoc(): HttpHeaders {
  //   const token = sessionStorage.getItem('authToken');
  //   const sessionUuid = sessionStorage.getItem('sessionUuid');
  //   const contentUuid = sessionStorage.getItem('content-uuid')
  //   let headers = new HttpHeaders({
  //     Authorization: `Bearer ${token}`,
  //   });

  //   if (sessionUuid) {
  //     headers = headers.set('content-uuid', sessionUuid);
  //   }
  //   if (contentUuid) {
  //     headers = headers.set('content-uuid', contentUuid);
  //   }
  //   return headers;
  // }

  constructor(
    private http: HttpClient,
    private loggingService: LoggingService
  ) { }

  signIn(email: string, password: string): Observable<any> {
    this.loggingService.log('login trigger');

    const headers = new HttpHeaders({
      'Authorization': 'Basic ' + btoa(`${email}:${password}`),
    });

    return this.http.post(`${this.api}login`, {}, { headers });
  }
  getModules(): Observable<{ message: string; data: Module[] }> {
    const headers = this.getHeaders();
    return this.http.get<{ message: string; data: Module[] }>(
      `${this.api}doctor/modules`,
      { headers }
    );
  }
  getModuleById(moduleId: string): Observable<ModuleResponse> {
    const url = `${this.api}doctor/module/${moduleId}`;
    const headers = this.getHeadersUuid();
    return this.http.get<ModuleResponse>(url, { headers });
  }
  getItemAccess(
    moduleId: string,
    itemId: string,
    itemType: string
  ): Observable<any> {
    const headers = this.getHeaders();

    const url = `${this.api}doctor/module/${moduleId}/items/${itemId}/access?itemType=${itemType}`;
    this.loggingService.log('apiddd', url);

    return this.http.get<ItemAccess>(url, { headers });
  }
  startVideo(
    moduleId: string,
    videoId: string,
    accessKey: string
  ): Observable<any> {
    // Get the existing headers
    const headers = this.getHeadersContentUuid().append(
      'Module-access-Key',
      accessKey
    );

    const url = `${this.api}doctor/module/${moduleId}/video/${videoId}/start`;
    this.loggingService.log('apiurl', url);
    return this.http.post(url, {}, { headers });
  }
  updateWatchDuration(
    moduleId: string,
    videoId: string,
    watchDuration: number,
    accessKey: string
  ): Observable<any> {
    const headers = this.getHeadersContentUuid().append(
      'Module-access-Key',
      accessKey
    );
    const apiUrl = `${this.api}doctor/module/${moduleId}/videos/${videoId}/progress`;
    return this.http.post(apiUrl, { watchDuration }, { headers });
  }
  updateProfilePic(file: File): Observable<any> {
    const headers = this.getHeaders();
    const formData = new FormData();
    formData.append('profilePic', file);
    return this.http.put(`${this.api}doctor/profilepic`, formData, { headers });
  }


  sendOtp(email: string): Observable<any> {
    return this.http.post<any>(`${this.api}doctor/forgetPassword`, { email });
  }

  sendDocOtp(email: string): Observable<any> {
    return this.http.post<any>(`${this.api}anonymous/generate-otp`, { email });
  }

  startMeeting(webinarId: string): Observable<any> {
    const timeZone = this.getUserTimezone();
    const headers = this.getHeaders(); // Ensure headers are properly defined
    const url = `${this.api}webinar/start/${webinarId}?timeZone=${encodeURIComponent(timeZone)}`;

    return this.http.get<any>(url, { headers }); // Corrected GET request
  }


  verifyOtp(data: {
    email: string;
    refKey: string;
    otp: string;
  }): Observable<any> {
    return this.http.post<any>(`${this.api}anonymous/verify-otp`, data);
  }

  resetPassword(
    email: string,
    otp: string,
    newPassword: string,
    confirmPassword: string
  ): Observable<any> {
    const payload = {
      email,
      otp,
      newPassword,
      confirmPassword,
    };
    this.loggingService.log('Payload being sent:', payload);
    return this.http.post(`${this.api}anonymous/resetPassword`, payload);
  }
  getProfile(): Observable<any> {
    const headers = this.getHeaders();
    return this.http.get<DoctorProfile>(`${this.api}doctor/profile`, {
      headers,
    });
  }
  getDoctors(
    page: number,
    limit: number,
    searchKeyWord?: string,
    roleId?: string
  ): Observable<any> {
    const headers = this.getHeaders();
    let url = `${this.api}admin/doctors?page=${page}&limit=${limit}`;

    if (searchKeyWord?.trim()) {
      url += `&searchKeyWord=${encodeURIComponent(searchKeyWord)}`;
    }

    if (roleId) {
      url += `&id=${roleId}`; // ✅ role filter
    }

    return this.http.get<any>(url, { headers });
  }

  reminderBlast(webinarId: string, blastFor: string) {
    const headers = this.getHeaders();
    const params = new HttpParams().set('blastFor', blastFor);
    return this.http.get(`${this.api}webinar/reminderblast/${webinarId}`, { headers, params });
  }

  managePanelist(
    webinarId: string,
    action: 'GET' | 'NEW' | 'DELETE' = 'GET',
    panelistData?: any,
    panelistId?: string
  ): Observable<any> {
    let url = `${this.api}webinar/panelist/${webinarId}?action=${action}`;
    if (action === 'DELETE' && panelistId) {
      url += `&panelistId=${panelistId}`;
    }
    const headers = this.getHeaders();
    const body = action === 'GET' ? {} : panelistData;
    return this.http.post(url, body, { headers });
  }


  getwebinar(
    page: number,
    limit: number,
    searchKeyWord: string = '',
  ): Observable<any> {
    const headers = this.getHeaders();
    const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    let url = `${this.api}getWebinars?page=${page}&limit=${limit}&timeZone=${encodeURIComponent(timeZone)}&event=upcoming`;

    if (searchKeyWord.trim()) {
      url += `&searchKeyWord=${encodeURIComponent(searchKeyWord)}`;
    }

    return this.http.get<any>(url, { headers });
  }

  // getModuleAnalytics(): Observable<ModuleReportResponse> {
  //   const headers = this.getHeaders();  
  //   const url = `${this.api}module/analaytics`;

  //   return this.http.get<ModuleReportResponse>(url, { headers });
  // }
  getModuleAnalytics(moduleId?: string): Observable<ModuleReportResponse> {
    const headers = this.getHeaders();
    const url = `${this.api}module/analaytics`;

    let params = new HttpParams();
    if (moduleId) {
      params = params.set('moduleId', moduleId);
    }

    return this.http.get<ModuleReportResponse>(url, { headers, params });
  }

  getWebinarAnalytics(webinarId?: string, timeZone: string = 'Asia/Calcutta'): Observable<WebApiResponse> {
    const headers = this.getHeaders();
    const url = `${this.api}webinar/analytics`;

    let params = new HttpParams().set('timeZone', timeZone);
    if (webinarId) {
      params = params.set('webinarId', webinarId);
    }

    return this.http.get<WebApiResponse>(url, { headers, params });
  }

  getwebinarpast(
    page: number,
    limit: number,
    searchKeyWord: string = '',
  ): Observable<any> {
    const headers = this.getHeaders();
    const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    let url = `${this.api}getWebinars?page=${page}&limit=${limit}&timeZone=${encodeURIComponent(timeZone)}&event=past`;

    if (searchKeyWord.trim()) {
      url += `&searchKeyWord=${encodeURIComponent(searchKeyWord)}`;
    }

    return this.http.get<any>(url, { headers });
  }


  getWebinarDetails(id: string): Observable<any> {
    const headers = this.getHeaders();
    const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone; // Get user's current timezone
    const apiUrl = `${this.api}getWebinarsDetails/${id}?timeZone=${encodeURIComponent(timeZone)}`;

    return this.http.get<any>(apiUrl, { headers });
  }
  getWebinarReportDownload(webinarId: string, downloadExcel: boolean): Observable<string> {
    const headers = this.getHeaders();
    const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    const apiUrl = `${this.api}webinar/reportDownload?timeZone=${encodeURIComponent(timeZone)}&webinarId=${webinarId}&downloadExcel=${downloadExcel}`;

    return this.http.get(apiUrl, {
      headers,
      responseType: 'text'  // ⬅️ Expect CSV or plain text
    });
  }
  getWebinarReport(
    webinarId: string,
    downloadExcel: boolean,
    reportType: string
  ): Observable<string> {
    const headers = this.getHeaders();
    const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;

    const apiUrl = `${this.api}webinar/reportDownload` +
      `?timeZone=${encodeURIComponent(timeZone)}` +
      `&webinarId=${webinarId}` +
      `&downloadExcel=${downloadExcel}` +
      `&reportType=${reportType}`;

    return this.http.get(apiUrl, {
      headers,
      responseType: 'text',
    });
  }

  copyWebinar(webinarId: string): Observable<any> {
    const headers = this.getHeaders(); // Returns HttpHeaders
    const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    const url = `${this.api}webinar/copyWebinar/${webinarId}?timeZone=${encodeURIComponent(timeZone)}`;

    return this.http.get(url, { headers });
  }




  getNews(
    page: number,
    limit: number,
    searchKeyWord: string = ''
  ): Observable<NewsResponse> {
    const headers = this.getHeaders();
    const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;

    let url = `${this.api}news?page=${page}&limit=${limit}&timeZone=${encodeURIComponent(timeZone)}`;
    if (searchKeyWord.trim()) {
      url += `&searchKeyWord=${encodeURIComponent(searchKeyWord)}`;
    }

    return this.http.get<NewsResponse>(url, { headers });
  }
  getBooks(
    page: number,
    limit: number,
    searchKeyWord: string = ''
  ): Observable<BookResponse> {
    const headers = this.getHeaders();
    const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;

    let url = `${this.api}elibrary/get-books-list?page=${page}&limit=${limit}&timeZone=${encodeURIComponent(timeZone)}`;
    if (searchKeyWord.trim()) {
      url += `&searchKeyWord=${encodeURIComponent(searchKeyWord)}`;
    }

    return this.http.get<BookResponse>(url, { headers });
  }
  getModules_list(
    page: number,
    limit: number,
    searchKeyWord: string = ''
  ): Observable<ModuleListResponse> {
    const headers = this.getHeaders();
    const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;

    let url = `${this.api}module?page=${page}&limit=${limit}&timeZone=${encodeURIComponent(timeZone)}`;
    if (searchKeyWord.trim()) {
      url += `&searchKeyWord=${encodeURIComponent(searchKeyWord)}`;
    }

    return this.http.get<ModuleListResponse>(url, { headers });
  }


  getNewsById(newsId: string, timeZone: string): Observable<NewsItem> {
    const headers = this.getHeaders();
    const url = `${this.api}news/${newsId}?timeZone=${encodeURIComponent(timeZone)}`;

    return this.http.get<{ data: NewsItem }>(url, { headers }).pipe(
      map(response => response.data) // 👈 Extract the data object
    );
  }

  getWebinarCount(): Observable<WebinarCountsResponse> {
    const headers = this.getHeaders();
    const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;

    return this.http.get<WebinarCountsResponse>(
      `${this.api}webinarCount/v1/get?timeZone=${timeZone}`,
      { headers }
    );
  }


  updateDoctorStatus(ids: string[], action: string): Observable<any> {
    const headers = this.getHeaders();
    const payload = {
      _ids: ids,
      action: action,
    };
    return this.http.put(`${this.api}admin/doctor/update/access`, payload, {
      headers,
    });
  }

  addDoctor(doctorData: { name: string; email: string }): Observable<any> {
    const headers = this.getHeaders();
    return this.http.post(`${this.api}admin/addDoctor`, doctorData, {
      headers,
    });
  }
  updateDoctor(doctorData: { id: string; name: string; email: string; type: string }): Observable<any> {
    const headers = this.getHeaders();
    return this.http.post(`${this.api}admin/addDoctor?type=UPDATE`, doctorData, { headers });
  }

  resendVerification(id: string): Observable<any> {
    const headers = this.getHeaders();
    const payload = { id };

    this.loggingService.log('Sending payload:', JSON.stringify(payload)); // ✅ Log the exact payload before sending

    return this.http.post(`${this.api}admin/doctor/resendVerification`, payload, { headers });
  }


  updateProfile(name: string): Observable<any> {
    const headers = this.getHeaders();
    return this.http.post(
      `${this.api}updateProfile`,
      { name },
      { headers }
    );
  }
  submitExam(
    moduleId: string,
    testId: string,
    answers: any[],
    contentAccess: string | null
  ) {
    const url = `${this.api}doctor/module/${moduleId}/tests/${testId}/submit`;
    const payload = { answers };
    let headers = this.getHeadersContentUuid();

    if (contentAccess) {
      headers = headers.append('Module-access-Key', contentAccess);
      this.loggingService.log('Module-access-Key:', contentAccess);
    }

    this.loggingService.log('API URL:', url);
    return this.http.post(url, payload, { headers });
  }
  callSessionApi(): Observable<any> {
    const headers = this.getHeaders();
    return this.http.get(`${this.api}doctor/session`, { headers });
  }
  registerDoctor(doctorData: any): Observable<any> {
    const headers = this.getDocHeaders();
    return this.http.post<any>(`${this.api}doctor/register`, doctorData, {
      headers,
    });
  }
  getCertificate(
    moduleId: string,
    certificateId: string,
    type: string,
    contentAccess: string | null
  ): Observable<any> {
    const url = `${this.api}doctor/module/${moduleId}/certificate/${certificateId}`;
    const params = new HttpParams().set('type', type);
    let headers = this.getHeadersContentUuid();

    if (contentAccess) {
      headers = headers.append('Module-access-Key', contentAccess);
    }

    // Log headers to verify
    this.loggingService.log('Headers:', headers.keys());
    headers.keys().forEach((key) => {
      this.loggingService.log(`${key}: ${headers.get(key)}`);
    });

    return this.http.post(url, {}, { headers, params });
  }
  submitSurvey(
    moduleId: string,
    surveyId: string,
    responses: any,
    contentAccess: string | null
  ): Observable<any> {
    const url = `${this.api}doctor/module/${moduleId}/survey/${surveyId}/submit`;
    let headers = this.getHeadersContentUuid();

    if (contentAccess) {
      headers = headers.append('Module-access-Key', contentAccess);
    }
    // Log headers for verification
    this.loggingService.log('Headers for submitSurvey:', headers.keys());
    headers.keys().forEach((key) => {
      this.loggingService.log(`${key}: ${headers.get(key)}`);
    });

    return this.http.post(url, responses, { headers });
  }
  createOrUpdateWebinar(
    webinarData: FormData,
    isEditMode: boolean,
    webinarId?: string | null
  ): Observable<any> {

    const headers = this.getHeaders();
    const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    const encodedTimeZone = encodeURIComponent(timeZone);

    let fullUrl = `${this.api}createwebinar?`;

    if (isEditMode && webinarId) {
      fullUrl += `action=UPDATE&id=${webinarId}&timeZone=${encodedTimeZone}`;
    } else {
      fullUrl += `action=NEW&timeZone=${encodedTimeZone}`;
    }

    return this.http.post(fullUrl, webinarData, { headers });
  }
  deleteWebinar(webinarId: string): Observable<any> {
    const headers = this.getHeaders();
    return this.http.delete(`${this.api}/webinar/${webinarId}`, { headers });
  }

  updateNewsStatus(newsId: string, actionType: string): Observable<ApiResponse> {
    const headers = this.getHeaders();
    return this.http.put<ApiResponse>(`${this.api}news/${newsId}`, { actionType }, { headers });
  }
  updateEditStatus(newsId: string): Observable<any> {
    const headers = this.getHeaders();
    const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    const url = `${this.api}news/${newsId}?timeZone=${encodeURIComponent(timeZone)}`;

    return this.http.get(url, { headers });
  }
  // updateNews(newsId: string, formData: FormData, action: string = 'UPDATE', ): Observable<any> {
  //   const headers = this.getHeaders(); // Don't set 'Content-Type', let browser handle it for FormData
  //   const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
  //   const url = `${this.api}news?timeZone=${encodeURIComponent(timeZone)}&action=${encodeURIComponent(action)}&newsId=${encodeURIComponent(newsId)}`;

  //   return this.http.put(url, formData, { headers });
  // }
  updateNews(newsId: string, formData: FormData, action: string = 'UPDATE'): Observable<any> {
    const headers = this.getHeaders(); // Don't set 'Content-Type', let browser handle it for FormData
    const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    const currentDate = new Date().toISOString();
    const url = `${this.api}news?timeZone=${encodeURIComponent(timeZone)}&action=${encodeURIComponent(action)}&newsId=${newsId}`;
    formData.append('launchDate', currentDate);
    return this.http.post(url, formData, { headers }); // Changed from PUT to POST
  }

  createNews(formData: FormData): Observable<any> {
    const headers = this.getHeaders(); // Auth headers if needed
    const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    const url = `${this.api}news?timeZone=${encodeURIComponent(timeZone)}`;
    const currentDate = new Date().toISOString();
    formData.append('launchDate', currentDate);

    return this.http.post(url, formData, { headers });
  }


  deleteNews(newsId: string) {
    const headers = this.getHeaders();
    return this.http.delete(`${this.api}news/${newsId}`, { headers });
  }

  deleteBook(bookId: string) {
    const headers = this.getHeaders();
    return this.http.delete(`${this.api}elibrary/books/${bookId}`, { headers });
  }

  publishBook(bookId: string) {
    const headers = this.getHeaders();
    return this.http.patch(`${this.api}elibrary/books/${bookId}`, {}, { headers });
  }
  viewBook(bookId: string) {
    const headers = this.getHeaders();
    return this.http.get<any>(`${this.api}elibrary/book-pre-signed-url/${bookId}`, { headers });
  }
  public getPreSignedUrl(payload: any): Observable<{ uploadUrl: string; fileId: string }> {
    const headers = this.getHeaders();

    return this.http.post<{ uploadUrl: string; fileId: string }>(
      `${this.api}elibrary/presigned-url`,
      payload,
      { headers }
    );
  }

  updateBook(bookId: string, title: string, author: string) {
    const headers = this.getHeaders();
    return this.http.put(`${this.api}elibrary/books/${bookId}`, { title, author }, { headers });
  }


  getDoctorDetails(doctorId: string): Observable<ProfileDynamicDetailsResponse> {
    const headers = this.getHeaders();
    const url = `${this.api}admin/doctor/${doctorId}`;
    return this.http.get<ProfileDynamicDetailsResponse>(url, { headers });
  }
  getReports(page: number): Observable<ReportResponse> {
    const timeZone = this.getUserTimezone();
    const headers = this.getHeaders();
    const url = `${this.api}downloadreport?timeZone=${encodeURIComponent(timeZone)}`;

    const params = new HttpParams().set('page', page);

    return this.http.get<ReportResponse>(url, { params, headers });
  }


  generateLink(id: string): Observable<any> {
    const headers = this.getHeaders();
    const url = `${this.api}generateLink?id=${encodeURIComponent(id)}`;
    return this.http.get<any>(url, { headers });
  }


  downloadreport(): Observable<any> {
    const headers = this.getHeaders();
    const url = `${this.api}admin/doctors/downloadreport`;
    return this.http.get<any>(url, { headers });
  }
  getWebinarData(
    event: 'specificMonth' | 'specificWeek' | 'daily',
    month: number,
    year: number,
    timezone?: string,
    date?: string,
    weekNumber?: number
  ): Observable<any> {
    const headers = this.getHeaders();

    // Detect timezone if not provided
    const resolvedTimezone = timezone || Intl.DateTimeFormat().resolvedOptions().timeZone;

    let params = new HttpParams()
      .set('event', event)
      .set('year', year.toString())
      .set('month', month.toString())
      .set('timezone', resolvedTimezone);

    if (event === 'daily' && date) {
      params = params.set('date', date);
    }

    if (event === 'specificWeek' && weekNumber) {
      params = params.set('week', weekNumber.toString());
    }

    return this.http.get<any>(`${this.api}calendar/webinar`, { headers, params });
  }
  getTenantUI(): Observable<TenantUIResponse> {
    return this.http.get<TenantUIResponse>(`${this.api}tenant/ui`);
  }

  getSurveyAnalytics(moduleId: string, surveyId: string): Observable<any> {
    const headers = this.getHeaders();
    const url = `${this.api}survey/v1/analytics`;

    const body = {
      moduleId,
      surveyId
    };

    return this.http.post<any>(url, body, { headers });
  }

  getSlideranAlytics(moduleId: string, surveyId: string): Observable<any> {
    const headers = this.getHeaders();
    const url = `${this.api}survey/v1/slideranalytics`;

    const body = {
      moduleId,
      surveyId
    };

    return this.http.post<any>(url, body, { headers });
  }


  getSurveyList(moduleId: string): Observable<SurveyListResponse> {
    const headers = this.getHeaders();
    const url = `${this.api}mod-survey/v1/survey-list`;

    const body = { moduleId };

    return this.http.post<SurveyListResponse>(url, body, { headers });
  }

  downloadReportDoc(moduleId: string, reportType: string = 'module'): Observable<any> {
    const timeZone = this.getUserTimezone();
    const headers = this.getHeaders();
    const url = `${this.api}module-rep/doctors/downloadreport?timezone=${encodeURIComponent(timeZone)}`;

    const body = {
      moduleId: moduleId,
      reportType: reportType
    };

    return this.http.post<any>(url, body, { headers });
  }

  downloadSurveyReport(moduleId: string, surveyId: string, reportType: string = 'survey'): Observable<any> {
    const timeZone = this.getUserTimezone();
    const headers = this.getHeaders();
    const url = `${this.api}module-rep/doctors/downloadreport?timezone=${encodeURIComponent(timeZone)}`;

    const body = {
      moduleId: moduleId,
      surveyId: surveyId,
      reportType: reportType
    };

    return this.http.post<any>(url, body, { headers });
  }


  getDoctorsList(
    moduleId: string,
    page: number = 1,
    search: string = ''
  ): Observable<DoctorsListResponse> {
    const headers = this.getHeaders();
    const url = `${this.api}module-process/doctors_list`;

    const body = {
      moduleid: moduleId,
      page,
      search
    };

    return this.http.post<DoctorsListResponse>(url, body, { headers });
  }

  getModuleCompleted(moduleId: string): Observable<any> {
    const headers = this.getHeaders();
    const url = `${this.api}module-report/module-completed`;
    const body = { moduleId };

    return this.http.post<any>(url, body, { headers });
  }

  getModuleCompletedWithoutBody(): Observable<any> {
    const headers = this.getHeaders();
    const url = `${this.api}module-report/module-completed`;

    // Send empty body or null
    return this.http.post<any>(url, {}, { headers });
  }
  getFeatureOptions(): Observable<any> {
    const headers = this.getHeaders();
    const url = `${this.api}features/options`;
    return this.http.get<any>(url, { headers });
  }


  getWebinarAnalyticsLatAll(): Observable<any> {
    const headers = this.getHeaders();
    const timeZone = this.getUserTimezone();
    const url = `${this.api}zoom/analytics?timeZone=${encodeURIComponent(timeZone)}`;
    return this.http.get<any>(url, { headers });
  }

  getNewsReportAnalytics(body?: any): Observable<any> {
    const headers = this.getHeaders();
    const url = `${this.api}news-report/view-analytics`;
    return this.http.post<any>(url, body || {}, { headers });
  }

  getNewServiceRequest(body: any): Observable<any> {
    const headers = this.getHeaders();
    const url = `${this.api}features/newServiceRequest`;
    return this.http.post<any>(url, body, { headers });
  }


  /** 📚 Get all groups */
  getGroups(): Observable<any> {
    const headers = this.getHeaders();
    return this.http.get(`${this.api}user-group/list-group`, { headers });
  }

  /** 🔑 Get all permissions */
  getPermissions(): Observable<any> {
    const headers = this.getHeaders();
    return this.http.get(`${this.api}permission/get`, { headers });
  }

  /** 👤 Create user */
  createUser(data: any): Observable<any> {
    const headers = this.getHeaders();
    return this.http.post(`${this.api}rbac/user`, data, { headers });
  }


  setPassword(payload: any): Observable<any> {
    this.loggingService.log('login trigger');
    // const headers = this.getHeaders();
    return this.http.post(`${this.api}rbac/user/password-reset`, payload);
  }

  getAdminUsersList() {
    const headers = this.getHeaders();
    return this.http.get<any>(`${this.api}rbac/user`, { headers });
  }

  getUserById(id: string) {
    const headers = this.getHeaders();
    return this.http.get(`${this.api}rbac/user/${id}`, { headers });
  }

  updateUser(id: string, data: any) {
    const headers = this.getHeaders();
    return this.http.put(`${this.api}rbac/user/${id}`, data, { headers });
  }

  deleteUser(id: string) {
    const headers = this.getHeaders();
    return this.http.delete(`${this.api}rbac/user/${id}`, { headers });
  }


  createGroup(data: any): Observable<any> {
    const headers = this.getHeaders();
    return this.http.post(`${this.api}user-group/create-group`, data, { headers });
  }

  getGroupList() {
    const headers = this.getHeaders();
    return this.http.get<any>(`${this.api}user-group/list-group`, { headers });
  }

  getGroupById(id: string) {
    const headers = this.getHeaders();
    return this.http.get(`${this.api}user-group/get-group/${id}`, { headers });
  }

  updateGroup(id: string, data: any) {
    const headers = this.getHeaders();
    return this.http.put(`${this.api}user-group/update-group/${id}`, data, { headers });
  }

  deleteGroup(id: string) {
    const headers = this.getHeaders();
    return this.http.delete(`${this.api}user-group/delete-group/${id}`, { headers });
  }


  confirmEmailSend(id: string) {
    const headers = this.getHeaders();
    return this.http.post(`${this.api}rbac/user/resend-email`, { userId: id }, { headers });
  }

  getUserPermission(): Observable<PermissionResponse> {
    const headers = this.getHeaders();
    return this.http.get<PermissionResponse>(`${this.api}rbac/user/permission`, { headers });
  }

 getDynamicProfileAnalysis(roleId?: string): Observable<any> {
  const headers = this.getHeaders();

  let params: any = {};

  if (roleId) {
    params.id = roleId;
  }

  return this.http.get<any>(
    `${this.api}dynamicProfile/Analysis`,
    {
      headers,
      params
    }
  );
}
  getCategory(): Observable<any> {
    const headers = this.getHeaders();
    return this.http.get<any>(`${this.api}category`, { headers });
  }
  getRoles(): Observable<any> {
    const headers = this.getHeaders();
    return this.http.get<any>(`${this.api}category`, { headers });
  }
  categoryMultiple(body: any): Observable<any> {
    const headers = this.getHeaders();
    return this.http.post<any>(`${this.api}category-multiple`, body, { headers });
  }

  requestRoleChange(payload: { endUserId: string; roleId: string }): Observable<any> {
    const headers = this.getHeaders();
    return this.http.post<any>(
      `${this.api}updateRoleReq`,
      payload,
      { headers }
    );
  }


  getCategoriesByRole(roleId: string): Observable<any> {
    const headers = this.getHeaders();

    return this.http.get<any>(`${this.api}category?id=${roleId}`, { headers });
  }

  getCategoryById(id: string): Observable<any> {
    const headers = this.getHeaders();
    return this.http.get<any>(`${this.api}category?id=${id}`, { headers });
  }

  getUserDetailsById(): Observable<any> {
    const headers = this.getHeaders();
    return this.http.get<any>(`${this.api}userDetails`, { headers });
  }

  generateOtp(email: string): Observable<any> {
    const headers = this.getHeaders();
    const body = { email: email };

    return this.http.post<any>(`${this.api}anonymous/generate-otp`, body, { headers });
  }

  // Service - Keep original method
  // In your service:
  getPodcastList(page: number, limit: number, searchText?: string): Observable<any> {
    const timeZone = this.getUserTimezone();
    const headers = this.getHeaders();
    let url = `${this.api}podcast?page=${page}&limit=${limit}&timeZone=${encodeURIComponent(timeZone)}`;

    // Add search parameter if provided
    if (searchText) {
      url += `&search=${encodeURIComponent(searchText)}`;
    }

    return this.http.get<any>(url, { headers });
  }
  // Service - Add new method with search and filter
  getPodcastListWithFilters(
    page: number,
    limit: number,
    searchTerm?: string,
    status?: string
  ): Observable<any> {
    const timeZone = this.getUserTimezone();
    const headers = this.getHeaders();

    let url = `${this.api}podcast?page=${page}&limit=${limit}&timeZone=${encodeURIComponent(timeZone)}`;

    if (searchTerm) {
      url += `&search=${encodeURIComponent(searchTerm)}`;
    }

    if (status) {
      url += `&status=${encodeURIComponent(status)}`;
    }

    return this.http.get<any>(url, { headers });
  }
  getPodcastById(id: string): Observable<any> {
    const timeZone = this.getUserTimezone();
    const headers = this.getHeaders();

    const url = `${this.api}podcast/${id}?timeZone=${encodeURIComponent(timeZone)}`;

    return this.http.get<any>(url, { headers });
  }



  changePassword(
    currentPassword: string,
    newPassword: string,
    confirmPassword: string
  ): Observable<{ message: string }> {

    const body = {
      currentPassword,
      newPassword,
      confirmPassword,
    };

    const headers = this.getHeaders();
    this.loggingService.log('Payload being sent:', body);

    return this.http.post<{ message: string }>(
      `${this.api}changePassword`,
      body,
      { headers }
    );
  }

  getUserFullReport(
    userId: string,
    responseType: 'normal' | 'ai_summary' = 'normal'
  ): Observable<any> {
    const timeZone = this.getUserTimezone();
    const headers = this.getHeaders();

    let url =
      `${this.api}getFullReportForSpecificUser/${userId}` +
      `?timeZone=${encodeURIComponent(timeZone)}`;

    if (responseType === 'ai_summary') {
      url += `&response_type=ai_summary`;

      // 👇 HTML response
      return this.http.get(url, {
        headers,
        responseType: 'text'
      });
    }

    // 👇 JSON response (default behavior)
    return this.http.get<any>(url, { headers });
  }
  getAdminRoles(): Observable<any> {
    const headers = this.getHeaders();
    return this.http.get<any>(
      `${this.api}admin/role`,
      { headers }
    );
  }

  getPresignedUrlUploadCsv(payload: any): Observable<any> {
    const headers = this.getHeaders();
    return this.http.post(
      `${this.api}admin/doctor/getPresignedUrlUploadCsv`,
      payload,
      { headers }
    );
  }
  uploadDoctorsCSV(payload: {
    s3Key: string;
    roleId: string;
  }): Observable<any> {

    const headers = this.getHeaders();

    return this.http.post(
      `${this.api}admin/doctor/uploadDoctorsCSV`,
      payload,
      { headers }
    );
  }

  getUserAssessment() {
    const headers = this.getHeaders();
    return this.http.get<any>(
      `${this.api}external/v1/user/assessment`,
      { headers }
    );
  }
  addAssessmentUser(payload: any) {
    const headers = this.getHeaders();

    return this.http.post<any>(
      `${this.api}external/v1/user/add`,
      payload,
      { headers }
    );
  }

  getUsers(
    page: number,
    limit: number,
    search?: string
  ): Observable<any> {
    const headers = this.getHeaders(); // reuse if you already have this
    let url = `${this.api}external/v1/user?page=${page}&limit=${limit}`;

    if (search?.trim()) {
      url += `&search=${encodeURIComponent(search)}`;
    }

    return this.http.get<any>(url, { headers });
  }
  getProductUserCount(paramsObj: any) {
    const headers = this.getHeaders();
    const timeZone = this.getUserTimezone();

    // convert paramsObj → query string
    const queryParams = new URLSearchParams({
      ...paramsObj,
      timeZone: timeZone
    }).toString();

    const url = `${this.api}productuser/v1/count?${queryParams}`;

    return this.http.get<any>(url, { headers });
  }
  updateUserName(name: string): void {
    this.userNameSubject.next(name);
  }

  updateUserAvatar(avatarUrl: string): void {
    this.userAvatarSubject.next(avatarUrl);
  }

  updateUserRole(role: string): void {
    this.userRoleSubject.next(role);
  }

  updateUserData(data: { name?: string; avatar?: string; role?: string }): void {
    if (data.name !== undefined) {
      this.userNameSubject.next(data.name);
    }
    if (data.avatar !== undefined) {
      this.userAvatarSubject.next(data.avatar);
    }
    if (data.role !== undefined) {
      this.userRoleSubject.next(data.role);
    }
  }

  // Get current values
  getCurrentUserName(): string {
    return this.userNameSubject.value;
  }

  getCurrentUserAvatar(): string {
    return this.userAvatarSubject.value;
  }


  getZoomAnalytics(webinarId: string): Observable<any> {
    const timeZone = this.getUserTimezone();
    const headers = this.getHeaders();

    const url = `${this.api}zoom/analytics&webinarId=${webinarId}&timeZone=${encodeURIComponent(timeZone)}`;

    return this.http.get<any>(url, { headers });
  }
  getWebinarAnalyticsLat(webinarId: string): Observable<any> {
    const headers = this.getHeaders();
    const timeZone = this.getUserTimezone();
    const url = `${this.api}zoom/analytics?webinarId=${webinarId}&timeZone=${encodeURIComponent(timeZone)}`;
    return this.http.get<any>(url, { headers });
  }
  getZoomEmailAnalytics(webinarId: string): Observable<any> {
    const headers = this.getHeaders();
    const timeZone = this.getUserTimezone();

    const url =
      `${this.api}zoom/email/analytics?webinarId=${webinarId}&timeZone=${encodeURIComponent(timeZone)}`;

    return this.http.get<any>(url, { headers });
  }

  getZoomOverallAnalytics(): Observable<any> {

    const headers = this.getHeaders();

    const timeZone = this.getUserTimezone();

    const url =
      `${this.api}zoom/analytics/overall?timeZone=${encodeURIComponent(timeZone)}`;

    return this.http.get<any>(url, { headers });
  }
}
